export default {
    methods: {
        async articleChangeActions($event, index) {
            const code = $event.data ? $event.data.code : null

            await this.articleChange($event, index)
            await this.autoselectLot(index, code)
        },
        // Autoseleccionar el mas nuevo de los lotes por _entityId
        async autoselectLot(index, code = null) {
            if (this.$refs?.lotAutocomplete[index] && code) {
                const filters = [
                    {
                        _ParentOperator: 'AND',
                        _Operator: 'AND',
                        Fields: {
                            article: {
                                type: 4,
                                string: code,
                                opt: '=',
                            },
                        },
                    },
                ]

                const result = await this.$gestios
                    .items('lots')
                    .list({ filters, order: { expiration_date: 'desc' }, limit: 1 })

                if (result.ok) {
                    const lot = result.data[0]

                    this.fields.concepts[index].lot = {
                        key: lot._EntityId,
                        label: lot.name,
                        data: lot,
                    }
                }
            }
        },
        // Modify concept prices for client before invoices is loaded
        async articleChange(event, index) {
            if (!this.loading) {
                let client = this.fields.client
                let article = event
                let articleId = event.key

                if (event.data) article = event.data
                if (client.data) client = client.data

                this.fields.concepts[index].name = article.name
                this.fields.concepts[index].iva = article.iva || 0

                // Llamar para buscar el precio segun la tarifa del clientes
                const rate =
                    typeof client.rate !== 'object' ? parseInt(client.rate, 10) : parseInt(client.rate._EntityId, 10)
                const price = await this.getPriceRate(articleId, rate)

                this.fields.concepts[index].price = price.pvp
                this.fields.concepts[index].discount = price.discount
                this.fields.concepts[index].lot = null
            }
        },
        // Set expiration date when lot change
        lotChange(lot, index) {
            if (lot && lot.data) {
                this.fields.concepts[index].expiration_date = lot.data.expiration_date
            }
        },
        async getPriceRate(article, rate) {
            try {
                if (rate) {
                    // Buscamos la tarifa
                    const res = await this.$gestios.items('prices').list({
                        filters: [
                            {
                                _ParentOperator: 'AND',
                                _Operator: 'AND',
                                Fields: {
                                    article: {
                                        type: 4,
                                        string: article,
                                        opt: '=',
                                    },
                                },
                            },
                            {
                                _ParentOperator: 'AND',
                                _Operator: 'AND',
                                Fields: {
                                    rate: {
                                        type: 3,
                                        int: rate,
                                        opt: '=',
                                    },
                                },
                            },
                        ],
                        silent: true,
                    })

                    if (res.ok) {
                        const price = res.data[0]

                        return {
                            pvp: price.pvp,
                            discount: price.discount,
                        }
                    }
                }

                return {
                    pvp: 0,
                    discount: 0,
                }
            } catch (err) {
                console.error(err)
                return {
                    pvp: 0,
                    discount: 0,
                }
            }
        },
    },
}
